import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Award } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { graduierungAPI } from '@/lib/api';

/* Gürtel & Einheiten im Profil (28.09.2026): auch für Personen ohne aktive
   Mitgliedschaft (die fehlen in der Graduierungs-Übersicht), z. B. Mitarbeiter.
   Einstufen = Gürtel ohne Push + Einheiten bis zur Zielzahl nachtragen. */
export default function GuertelKarte({ leadId }) {
  const [st, setSt] = useState(null);
  const [stufen, setStufen] = useState([]);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  const lade = useCallback(async () => {
    try { setSt((await graduierungAPI.status(leadId)).data); } catch { setSt(null); }
  }, [leadId]);
  useEffect(() => { lade(); graduierungAPI.stufen().then(r => setStufen(r.data.stufen || [])).catch(() => {}); }, [lade]);
  if (!st) return null;

  const speichern = async () => {
    setBusy(true);
    try {
      const r = await graduierungAPI.einstufen(leadId, form.stufe, form.einheiten === '' ? null : Number(form.einheiten));
      toast.success(`${r.data.label}, ${r.data.einheiten_jetzt} Einheiten${r.data.nachgetragen ? ` (${r.data.nachgetragen} nachgetragen)` : ''}`);
      setForm(null); lade();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Einstufen fehlgeschlagen'); }
    setBusy(false);
  };

  return (
    <Card className="border-border/60" data-testid="guertel-karte">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2"><Award className="w-4 h-4" /> Gürtel &amp; Einheiten
          <span className="ml-auto text-xs font-normal text-muted-foreground flex items-center gap-1.5">
            <span className="w-3 h-3 rounded-full border border-border" style={{ background: st.belt_color || '#eee' }} />{st.belt_label} · {st.trainings} Einheiten
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0 space-y-2">
        {!form ? (
          <Button size="sm" variant="outline" onClick={() => setForm({ stufe: st.belt, einheiten: String(st.trainings ?? '') })} data-testid="guertel-einstufen">Einstufen</Button>
        ) : (
          <div className="space-y-2">
            <p className="text-xs text-muted-foreground">Setzt den Gürtel ohne Benachrichtigung und trägt fehlende Einheiten bis zur Zielzahl nach. Vorhandene Einheiten werden nie gelöscht.</p>
            <div className="grid grid-cols-2 gap-2">
              <select value={form.stufe} onChange={e => setForm(f => ({ ...f, stufe: e.target.value }))} className="flex h-9 w-full rounded-md border border-input bg-background px-3 text-sm" data-testid="guertel-stufe">
                {stufen.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
              </select>
              <Input inputMode="numeric" placeholder="Einheiten gesamt" value={form.einheiten} onChange={e => setForm(f => ({ ...f, einheiten: e.target.value.replace(/\D/g, '') }))} className="h-9" data-testid="guertel-einheiten" />
            </div>
            <div className="flex gap-2">
              <Button size="sm" onClick={speichern} disabled={busy || !form.stufe} data-testid="guertel-speichern">Speichern</Button>
              <Button size="sm" variant="ghost" onClick={() => setForm(null)}>Abbrechen</Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
